/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import toastr from "toastr";

import {
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
  Spinner,
  Progress,
  Row,
  FormGroup,
  Card,
  CardBody,
  Button,
  Label,
  Badge,
} from "reactstrap";

import TextareaAutosize from "react-textarea-autosize";
import Viewer from "react-viewer";

//Redux
import { useSelector, useDispatch } from "react-redux";

// actions
import {
  getTabsChat,
  closeChat,
  tabulateChat,
  tabulateChatTicket,
  removeScrollMessage,
} from "../../../../store/operator/actions";
import { getAditionalFields, resetAditionalFields } from "../../../../store/aditionalFields/actions";

// Custom components
import Tabulation from "../Tabulation";

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation";

import { useForm } from "react-hook-form";

//i18n
import { withTranslation } from "react-i18next";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";

import schema from "./CloseValidation.js";

import mime from "mime";

import "./closeChat.scss";
import ActionNotAllowedModel from "../ActionNotAllowedModel";
import useHasPermission from "../../../../hooks/useHasPermission";

const CloseChat = ({
  t,
  toggle,
  isOpen,
  onSubmit,
  activeChat,
  isByManager,
  actionType,
  isDisplayTabs,
  isTabsRequired,
  massActions,
  isTicket,
  notes,
}) => {
  const userPermissions =
    useSelector((state) => state.Login?.data?.permissions) || [];
  const { messageOperator } = useSelector((state) => state.Operator);

  const { info: chatAditionalFields = {} } = useSelector(
    (state) => state.AditionalFields
  );
  
  const {
    data: { Authorization },
  } = useSelector((state) => state.Login);

  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(schema),
  });
  const setClassName = (errors) => {
    return errors ? "av-invalid is-invalid form-control" : "form-control";
  };

  const clientData = JSON.parse(localStorage.getItem('lastUser'));
  const sanitizeToDigits = useCallback((value) => String(value ?? "").replace(/\D/g, ""), []);

  const dispatch = useDispatch();
  const [showBlockTabulation, setShowBlockTabulation] = useState(false);

  const [listGrandpaTabs, setListGrandpaTabs] = useState([]);
  const [listDadTabs, setListDadTabs] = useState([]);
  const [listChildTabs, setListChildTabs] = useState([]);
  const [tabId, setTabId] = useState();
  const [text, setText] = useState("");
  const [privateNote, setPrivateNote] = useState("");
  const [privateNoteFacilAssist, setPrivateNoteFacilAssist] = useState(null);
  const [selectedGrandpaTab, setSelectedGrandpaTab] = useState();
  const [selectedDadTab, setSelectedDadTab] = useState();
  const [selectedChildTab, setSelectedChildTab] = useState();
  const [recivedTabs, setRecivedTabs] = useState();
  const [idToFind, setIdToFind] = useState();
  const [isSingleTab, setIsSingleTab] = useState(false);
  const [loadingMass, setLoadingMass] = useState(false);
  const [numberOfReturns, setNumberOfReturns] = useState({
    maximum: 0,
    current: 0,
  });
  const [fileObj, setFileObj] = useState([]);
  const [loadingFile, setLoadingFile] = useState(false);
  const [chatImages, setChatImages] = useState();
  const [visible, setVisible] = useState(false);
  const [openAccordion, setOpenAccordion] = useState(false);
  const [isInformative, setIsInformative] = useState(false);

  const fileInputRef = useRef(null);

  const [tabulationLoadingTicket, setTabulationLoadingTicket] = useState(false);

  const handleSetIsDefault = () => {
    setIsInformative(false);
  };

  const handleSetIsInformative = () => {
    setIsInformative(true);
  };
  const blockTabulation = useMemo(()=>{
    return (chatAditionalFields[activeChat?.conversation?.conversationId] ?? []).filter((ele)=> ele?.required && !ele?.value)?.length >  0;
  },[chatAditionalFields, activeChat]);

  const toggleBlockTabulation = useCallback(()=>{
    setShowBlockTabulation((old)=> !old);
  },[]);

  const handleCloseChat = () => {
    if (massActions?.conversations?.length > 0) {
      setLoadingMass(true);
      setNumberOfReturns({
        maximum: massActions.conversations.length,
        current: 0,
      });
      const requests = massActions.conversations.map(
        async (conversation, i) => {
          const [id, body] = closeConversations({
            conversationId: conversation.id,
            conversationTab: conversation.conversation_tab,
            consumer: {
              name: conversation.consumer_name,
            },
          });
          await new Promise((resolve) => setTimeout(resolve, i * 100));
          return axios
            .post(
              `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/change-status?id=${id}`,
              body,
              {
                Authorization,
              }
            )
            .then(() => {
              setNumberOfReturns((prev) => ({
                ...prev,
                current: prev.current + 1,
              }));
            });
        }
      );

      Promise.all(requests)
        .then(async () => {
          await new Promise((resolve) => setTimeout(resolve, 500));
          setLoadingMass(false);
          toggle();
          onSubmit &&
            onSubmit({
              error: false,
              message: t("Conversations closed"),
            });
        })
        .catch((error) => {
          setLoadingMass(false);
          let message = t("CHANGE: default error");
          if (error.response && error.response.status) {
            if (error.response.data && error.response.data.message)
              message = error.response.data.message;
            else message = error.message;
          }
          onSubmit &&
            onSubmit({
              error: true,
              message: message,
            });
        });
      return;
    }

    const [chatId, obj] = closeConversations(activeChat?.conversation);
    dispatch(closeChat(chatId, obj));
    dispatch(removeScrollMessage(chatId));
  };

  function closeConversations(conversation) {
    let chatId = conversation?.conversationId;
    if (conversation?.conversationId && conversation?.status !== "closed") {
      return handleChangeStatus({
        chatId: chatId,
        status: "closed",
        privateNote: privateNoteFacilAssist
      });
    } else {
      return handleChangeStatus({
        chatId: chatId,
        privateNote: privateNoteFacilAssist
      });
    }
  }

  const handleChangeStatus = (data) => {
    const obj = { status: data.status };
    if (tabId) {
      obj.tabId = tabId;
    }
    if (isByManager) {
      obj.byManager = true;
    }

    if (data.privateNote) {
      obj.privateNote = data.privateNote;
    }
    return [data.chatId, obj];
  };

  /**
   * Check if there's any error in the file and if it has add it into the object
   * @param {Object} files
   * @returns {Object} file with or without the error
   */
  const singleFileValidation = (file) => {
    const type = file?.type;
    const extension = file?.exts;
    const size = file?.size;
    const supportedFiles = activeChat?.conversation?.supportedFiles;

    try {
      //Validate FileType
      if (
        type === "image" ||
        type === "file" ||
        type === "audio" ||
        type === "video"
      ) {
        //Validate FileExt
        if (supportedFiles[type]?.ext?.includes(extension)) {
          const maxSizeToBytes =
            supportedFiles[type]?.metric === "KB"
              ? supportedFiles[type]?.maxSize * 1024
              : supportedFiles[type]?.metric === "MB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024
              : supportedFiles[type]?.metric === "GB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024
              : supportedFiles[type]?.metric === "TB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024 * 1024
              : supportedFiles[type]?.maxSize;
          //Validate FileSize
          if (size < maxSizeToBytes) {
            return { error: false, message: null };
          } else {
            return {
              error: true,
              message: `${t("Add files smaller than")} ${
                supportedFiles[type]?.maxSize
              } ${supportedFiles[type]?.metric}`,
            };
          }
        } else {
          const msgExt = ` ${t("Only")} ${t(type)} ${t(
            "with extension"
          )}: ${supportedFiles[type]?.ext?.join(", ")}`;
          return {
            error: true,
            message: `
            ${t("File extension not valid")}.
            ${supportedFiles[type]?.ext ? msgExt : ""}`,
          };
        }
      } else {
        return {
          error: true,
          message: t("File not valid"),
        };
      }
    } catch (error) {
      return {
        error: true,
        message: error,
      };
    }
  };

  /**
   * Validating files according to the channel validation
   * @param {Array<object>} files Array of all files to be validated
   * @returns {Array<object> || object} Returns if the files are valid or not
   */
  const allFilesValidation = (files) => {
    const errorsFiles = [];

    for (let i = 0; i < files.length; i++) {
      const error = singleFileValidation(files[i]);
      if (error?.error) errorsFiles.push(error);
    }

    return errorsFiles;
  };

  /**
   *
   * @param {string} type The type of the toast that's going to be displayed
   * @param {string} message The message that's going to be shown
   */
  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr[type](message);
  };

  /**
   * Render a gallery containing the attached images
   */
  const renderGallery = useMemo(() => {
    if (chatImages) {
      return (
        <Viewer
          visible={visible}
          onClose={() => {
            setVisible(false);
          }}
          images={chatImages}
          activeIndex={0}
          className="customViewer"
        />
      );
    }
  }, [chatImages, visible]);

  const renderChooseFile = useMemo(() => {
    if (fileObj?.length < 10) {
      return (
        <>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h5
              style={{
                fontSize: "13px",
                margin: "1em 0 1em",
                color: "#BBC4E0",
              }}
            >
              {t("Attach files to note")}
            </h5>
            <>
              <label
                id="attachfile"
                className="m-0 hoverCursor"
                htmlFor="file-input"
                style={{
                  height: "32px",
                  width: "200px",
                  left: "0px",
                  top: "29px",
                  borderRadius: "4px",
                  padding: "4px 12px",
                  border: "1px solid #556EE6",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <i
                  className="mdi mdi-upload mdi-24px noti-icon"
                  style={{ color: "#556EE6" }}
                ></i>
                <h5
                  style={{
                    fontSize: "13px",
                    margin: "1em 0 1em",
                    color: "#556EE6",
                    padding: "10px",
                  }}
                >
                  {t("Choose files")}
                </h5>
              </label>

              <input
                ref={fileInputRef}
                className="d-none"
                type="file"
                id="file-input"
                onChange={(e) => {
                  handleAddFile(e?.target?.files[0]);
                }}
                style={{
                  width: "100px",
                  height: "100px",
                }}
              />
            </>
          </div>
        </>
      );
    } else {
      return (
        <>
          <h5
            style={{
              fontSize: "13px",
              margin: "1em 0 1em",
              color: "#F46A6A",
            }}
          >
            {t("Maximum File Reached")}
          </h5>
        </>
      );
    }
  }, [fileObj]);

  /**
   * Function to render image
   * @param {object} item Item from the image that's being selected by the user
   * @returns {JSX.Element} Image Rendered from the input selected
   */
  const renderImage = (item) => {
    return (
      <div>
        {item?.type === "image" ? (
          <img
            src={item?.imgTest}
            className={"hoverCursor"}
            style={{
              width: "66px",
              height: "50px",
              padding: "0 0.5em",
              borderRadius: "1em",
            }}
            alt={`${item?.fileName}`}
            onClick={() => {
              setVisible(true);
            }}
          />
        ) : (
          <i
            style={{ fontSize: "50px" }}
            className={`bx ${
              item?.type === "file"
                ? "bx-file-blank"
                : item?.type === "image"
                ? "bx-image"
                : item?.type === "video"
                ? "bx-movie"
                : item?.type === "audio"
                ? "bx-music"
                : "bx-file-blank"
            } px-2  `}
          />
        )}
      </div>
    );
  };

  /**
   * Render JSX component containing all attached files
   * @returns {JSX.Element}
   */
  const renderAttachedFiles = useMemo(() => {
    if (loadingFile) {
      return (
        <Card className="my-1 pt-2">
          <CardBody className="overlflow-auto p-0">
            <Spinner animation="border" size="sm" />
          </CardBody>
          <hr className="dropdown-divider mb-0" />
        </Card>
      );
    }

    return fileObj?.length > 0 ? (
      fileObj.map((item, idx) => {
        if (idx > 0) {
          return (
            <>
              {idx === 1 && (
                <div
                  onClick={() => setOpenAccordion((prev) => !prev)}
                  style={{ display: "flex", flexDirection: "row" }}
                  className={"hoverCursor"}
                >
                  <h5 className="accordion ">{t("See other (...) files")}</h5>
                  <i
                    className={`mdi mdi-chevron-${
                      openAccordion === false ? "down" : "up"
                    }`}
                  ></i>
                </div>
              )}

              <div
                key={idx}
                className={`${
                  openAccordion ? "openAccordion" : "closeAccordion"
                }`}
              >
                {item?.error && (
                  <div className="d-flex mt-1">
                    <Badge color="danger" className="font-size-13 wrap-normal">
                      {item?.error?.message}
                    </Badge>
                  </div>
                )}
                <Card className="my-1 pt-2" key={idx}>
                  <CardBody className="overlflow-auto p-0 ">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex align-self-center w-100 overflow-auto">
                        {renderImage(item)}
                        <div className="overflow-auto">
                          <h5
                            style={{
                              fontSize: "13px",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0.15px",
                              textAlign: "left",
                              color: "#BBC4E0",
                              marginBottom: "0em",
                            }}
                          >
                            {item?.fileName}
                          </h5>
                          <h5
                            style={{
                              fontSize: "10.5px",
                              fontWeight: "400",
                              lineHeight: "24px",
                              letterSpacing: "0.15px",
                              textAlign: "left",
                              color: "#BBC4E0",
                            }}
                          >
                            {`${t("Size")} : ${(item?.size / 1000000).toFixed(
                              3
                            )} MB`}
                          </h5>
                        </div>
                      </div>
                      <div
                        className="align-self-center"
                        id="deletetooltip"
                        onClick={() => {
                          resetFile(item);
                        }}
                      >
                        <h5
                          className="hoverCursor"
                          style={{
                            fontSize: "13px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            letterSpacing: "0px",
                            textAlign: "left",
                            color: "#F46A6A",
                          }}
                        >
                          {t("Remove")}
                        </h5>
                      </div>
                    </div>
                  </CardBody>
                  <hr className="dropdown-divider mb-0" />
                </Card>
              </div>
            </>
          );
        }
        return (
          <React.Fragment key={idx}>
            {item?.error && (
              <div className="d-flex mt-1">
                <Badge color="danger" className="font-size-13 wrap-normal">
                  {item?.error?.message}
                </Badge>
              </div>
            )}
            <Card className="my-1 pt-2" key={idx}>
              <CardBody className="overlflow-auto p-0 ">
                <div className="d-flex justify-content-between">
                  <div className="d-flex align-self-center w-100 overflow-auto">
                    {renderImage(item)}
                    <div className="overflow-auto">
                      <h5
                        style={{
                          fontSize: "13px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          textAlign: "left",
                          color: "#BBC4E0",
                          marginBottom: "0em",
                        }}
                      >
                        {item?.fileName}
                      </h5>
                      <h5
                        style={{
                          fontSize: "10.5px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          letterSpacing: "0.15px",
                          textAlign: "left",
                          color: "#BBC4E0",
                        }}
                      >
                        {`${t("Size")} : ${(item?.size / 1000000).toFixed(
                          3
                        )} MB`}
                      </h5>
                    </div>
                  </div>
                  <div
                    className="align-self-center"
                    id="deletetooltip"
                    onClick={() => {
                      resetFile(item);
                    }}
                  >
                    <h5
                      className="hoverCursor"
                      style={{
                        fontSize: "13px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        letterSpacing: "0px",
                        textAlign: "left",
                        color: "#F46A6A",
                      }}
                    >
                      {t("Remove")}
                    </h5>
                  </div>
                </div>
              </CardBody>
              <hr className="dropdown-divider mb-0" />
            </Card>
          </React.Fragment>
        );
      })
    ) : (
      <></>
      /**
       <Card className="my-1 pt-2">
        <CardBody className="overlflow-auto p-0">
          <Spinner animation="border" size="sm" />
        </CardBody>
        <hr className="dropdown-divider mb-0" />
      </Card>
       */
    );
  }, [fileObj, loadingFile, openAccordion, chatImages]);

  /**
   * Function to "convert" file into base 64
   * @param {Event Element} file
   * @returns file converted to the base 64
   */
  const fileToBase64 = async (file) => {
    return new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
  };

  /**
   * Renders the image that's going to be seen by the user
   * @param {Event Element} file
   * @returns Object Url to be displayed in the frontend
   */
  const fileToPreview = (file) => {
    return URL.createObjectURL(file);
  };

  /**
   * Add a file to be sent along with the public note
   * @param {object} file file that's being selected by the user
   */
  const handleAddFile = async (file) => {
    if (file) {
      setLoadingFile(true);
      const fileBase64 = await fileToBase64(file);
      const dataSplit = fileBase64.split(",");

      const imgPreview = fileToPreview(file);

      const fileName = file?.name;
      const fileMimeType = file?.type;
      const fileType =
        fileMimeType.split("/")[0] === "application"
          ? "file"
          : fileMimeType.split("/")[0];
      const fileExts = mime?.getExtension(fileMimeType);
      const fileSize = file?.size;

      const formattedFile = {
        fileName: fileName,
        mimeType: fileMimeType,
        data: dataSplit[1],
        type: fileType,
        exts: fileExts,
        size: fileSize,
        imgTest: imgPreview,
      };

      const isValid = singleFileValidation(formattedFile);

      if (isValid?.error === true) {
        formattedFile.error = isValid;
      }

      setFileObj((prev) => [...prev, formattedFile]);

      if (fileType === "image") {
        if (chatImages) {
          setChatImages((prev) => [
            ...prev,
            { src: imgPreview, alt: fileName },
          ]);
        } else {
          setChatImages([{ src: imgPreview, alt: fileName }]);
        }
      }

      setLoadingFile(false);
    }
  };

  /**
   * A function that "resets" the files that are going to be sent
   * @param {object} item the file that is going to be "erased"
   */
  const resetFile = (item) => {
    if (fileInputRef?.current) fileInputRef.current.value = "";

    let newObj = fileObj;

    if (newObj?.length === 1) {
      setFileObj([]);
      setChatImages([]);
    } else {
      for (let i = 0; i < newObj.length; i++) {
        if (newObj[i] === item) {
          for (let x = 0; x < chatImages.length; x++) {
            if (chatImages[x].src === item.imgTest) {
              const tempChatImages = [...chatImages];
              tempChatImages.splice(x, 1);
              setChatImages(tempChatImages);
            }
          }

          newObj.splice(i, 1);
          break;
        }
      }
      setFileObj([...newObj]);
    }
  };

  const handleTabulateChat = () => {
    let chatId = activeChat?.conversation?.conversationId;
    dispatch(tabulateChat(chatId, { tabId: tabId, privateNoteFacilAssist: privateNoteFacilAssist }));
  };

  /**
   * Jsx Element that renders the channel limitation regarding files
   */
  const renderFilesLimitation = useMemo(() => {
    if (activeChat?.conversation?.supportedFiles) {
      const ext = [];
      if (activeChat?.conversation?.supportedFiles?.file?.ext?.length) {
        ext.push(...activeChat.conversation.supportedFiles.file.ext);
      }
      if (activeChat?.conversation?.supportedFiles?.image?.ext?.length) {
        ext.push(...activeChat.conversation.supportedFiles.image.ext);
      }
      if (activeChat?.conversation?.supportedFiles?.video?.ext?.length) {
        ext.push(...activeChat.conversation.supportedFiles.video.ext);
      }

      const textLimitation = `${t("Limit")}: ${t("10 files")} 
   
    `;
      const maximumFileSize = `${t("Maximum File Size")} : ${
        activeChat?.conversation?.supportedFiles?.file?.maxSize
      }  ${activeChat?.conversation?.supportedFiles?.file?.metric} `;

      const validExtension = ` ${t("Valid extensions")} : ${[...ext]}`;
      return (
        <>
          <p style={{ marginBottom: "0.1em" }}>{textLimitation}</p>
          <p style={{ marginBottom: "0.1em" }}>{maximumFileSize}</p>
          <p style={{ marginBottom: "0.1em" }}>{validExtension}</p>
        </>
      );
    }
  }, [activeChat?.conversation?.supportedFiles]);

  /**
   * Function that call the tabulation action
   */
  const handleTabulateTicket = () => {
    let valid = [];
    if(blockTabulation){
      toggleBlockTabulation();
      return;
    }

    if (fileObj?.length > 0) valid = allFilesValidation(fileObj);

    let chatId = activeChat?.conversation?.conversationId;
    setTabulationLoadingTicket(true);

    if (valid?.length > 0) {
      showToast("error", `${valid[0].message}`);
      return;
    }

    if (fileObj && valid?.length === 0) {
      // Se existir um ou mais arquivos sendo enviados e os mesmos são válidos
      dispatch(
        tabulateChatTicket(chatId, {
          tabId: tabId,
          text: text,
          privateNote: privateNote,
          files: fileObj,
          infoTab: isInformative,
          additionalFields: chatAditionalFields[chatId] ?? [],
        })
      );

      dispatch(resetAditionalFields(chatId));
    }
  };

  /**
   * @returns {boolean} if true the user is not allowed to tabulate or close chat
   */
  const userNotAllowed = useCallback(() => {
    if (
      !(
        Array.isArray(userPermissions?.["conversation-tab"]) &&
        userPermissions?.["conversation-tab"].includes("put")
      ) &&
      actionType === "tab"
    ) {
      return true;
    }

    if (
      !(
        Array.isArray(userPermissions?.conversation) &&
        userPermissions?.conversation.includes("put")
      ) &&
      actionType === "closeChat"
    ) {
      return true;
    }

    return false;
  }, [userPermissions, actionType]);

  const optionsTab = (existedData) => {
    let op = [];

    if (messageOperator?.status?.get_tabs_chat?.loading) {
      op.push({
        value: "loading",
        label: t("loading"),
        isDisabled: true,
      });
    } else if (Array.isArray(existedData)) {
      existedData.map((tab, key) =>
        op.push({
          key: key,
          value: tab.id,
          label: tab.name,
        })
      );
    } else {
      op.push({
        value: "empty",
        label: t("No matching records found"),
        isDisabled: true,
      });
    }

    return op;
  };

  useEffect(() => {
    let tabArray = [];
    //Check if is single Tab
    if (
      recivedTabs?.length === 1 &&
      !recivedTabs[0]?.children &&
      isDisplayTabs
    ) {
      setIsSingleTab(true);
      setTabId(recivedTabs[0].id);
    } else {
      setIsSingleTab(false);
      setTabId(null);
    }
    if (idToFind && !isInformative) {
      setTabId(idToFind);
      let controller = false;

      recivedTabs &&
        recivedTabs.forEach((element1) => {
          if (controller) {
            return;
          } else {
            tabArray[0] = {
              id: element1.id,
              name: element1.name,
            };

            if (element1.id === idToFind) {
              controller = true;
            }
          }
          element1?.children &&
            element1.children.forEach((element2) => {
              if (controller) {
                return;
              } else {
                tabArray[1] = {
                  id: element2.id,
                  name: element2.name,
                };
                if (element2.id === idToFind) {
                  controller = true;
                }
              }
              element2?.children &&
                element2.children.forEach((element3) => {
                  if (controller) {
                    return;
                  } else {
                    tabArray[2] = {
                      id: element3.id,
                      name: element3.name,
                    };
                    if (element3.id === idToFind) {
                      controller = true;
                    }
                  }
                });
            });
        });
    }
    setSelectedGrandpaTab(tabArray[0]?.id);
    setSelectedDadTab(tabArray[1]?.id);
    setSelectedChildTab(tabArray[2]?.id);
    setListGrandpaTabs(optionsTab(recivedTabs));
  }, [idToFind, recivedTabs, isInformative]);

  useEffect(() => {
    if (isOpen) {
      if (isTicket && isTicket === true) {
        setFileObj([]);
        setChatImages([]);
      }

      setTabId();
      dispatch(
        getTabsChat(
          activeChat?.conversation?.conversationId,
          massActions?.conversations.map((cvs) => cvs["id"]) || [],
          isInformative,
        )
      );
    }
  }, [isOpen, isInformative]);

  useEffect(() => {
    if (isTicket && tabulationLoadingTicket) {
      setTabulationLoadingTicket(false);
    }
    setIdToFind(activeChat?.conversation?.conversationTab);
    setText();
    setPrivateNote();
  }, [activeChat]);

  useEffect(() => {
    if (messageOperator?.data?.form?.tabs) {
      setRecivedTabs(messageOperator?.data.form.tabs);
    }
  }, [messageOperator]);

  useEffect(() => {
    setListDadTabs(
      optionsTab(
        recivedTabs &&
          recivedTabs.find((element) => element.id === selectedGrandpaTab)
            ?.children
      )
    );
  }, [selectedGrandpaTab]);

  listDadTabs.sort(function (a, b) {
    const textA = a.label.toUpperCase();
    const textB = b.label.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  useEffect(() => {
    setListChildTabs(
      optionsTab(
        recivedTabs &&
          recivedTabs
            ?.find((element1) => element1.id === selectedGrandpaTab)
            ?.children?.find((element2) => element2.id === selectedDadTab)
            ?.children
      )
    );
  }, [selectedDadTab]);

  listChildTabs.sort(function (a, b) {
    const textA = a.label.toUpperCase();
    const textB = b.label.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  useEffect(() => {
    if (massActions?.conversations?.length > 0) return;

    if (messageOperator?.status?.close_chat?.error) {
      onSubmit &&
        onSubmit({
          error: true,
          message: messageOperator.status.close_chat.error.message,
        });
    }
    if (messageOperator?.status?.close_chat?.success) {
      toggle();
      onSubmit &&
        onSubmit({
          error: false,
          message: t("Conversation closed"),
        });
    }
  }, [messageOperator.status?.close_chat]);

  const handleTitle = useMemo(() => {
    if (massActions?.conversations?.length > 0) {
      return actionType === "tab"
        ? t("Tabs of selected conversations")
        : t("Close selected chats");
    }

    return (
      (actionType === "tab" ? t("Tabulation") : t("Close chat")) +
      ` [${activeChat?.conversation?.consumer?.name}]`
    );
  }, [
    activeChat?.conversation?.consumer?.name,
    massActions?.conversations,
    actionType,
  ]);

  const checkTabulation = () => {
    if (
      (selectedGrandpaTab &&
        listDadTabs[0]?.value !== "empty" &&
        !selectedDadTab) ||
      (selectedDadTab &&
        listChildTabs[0]?.value !== "empty" &&
        !selectedChildTab)
    ) {
      return true;
    }

    return false;
  };

  const conversation = useMemo(() => activeChat?.conversation, [activeChat])
  const conversationId = useMemo(() => conversation?.id ?? conversation?.conversationId, [conversation])
  const additionalFieldsInfo = useSelector((state) => conversationId && state.AditionalFields?.info?.[conversationId]);
  const hasAdditionalFieldsPermission = useHasPermission('additional_fields_widgets', 'post')

  useEffect(() => {
    if (!isTicket) return;
    if (!hasAdditionalFieldsPermission) return

    if (!conversationId) return

    if (!additionalFieldsInfo) dispatch(getAditionalFields(conversationId))       
}, [hasAdditionalFieldsPermission, conversationId, additionalFieldsInfo]);

  return (
    <>
      <ActionNotAllowedModel
        isOpen={showBlockTabulation}
        handleClickCloseModalRequest={toggleBlockTabulation}
        msg={t("Please enter the values ​​in the required additional fields to continue")} 
      />
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={!messageOperator?.status?.close_chat?.loading}
      >
        <AvForm
          onValidSubmit={
            actionType === "tab"
              ? notes
                ? handleSubmit(handleTabulateTicket)
                : handleTabulateChat
              : handleCloseChat
          }
        >
          {userNotAllowed() ? (
            <>
              <ModalHeader className="modal-header-no-button" toggle={toggle}>
                {t("Action not allowed")}
              </ModalHeader>
            </>
          ) : (
            <>
              <ModalHeader className="modal-header-no-button" toggle={toggle}>
                {handleTitle}
              </ModalHeader>
              <div className="informative-tab-check">
                <Row>
                  <p>
                    {" "}
                    <i className="bx bx-info-circle" /> {t("Tab type")}:
                  </p>
                </Row>
                <Row className="mb-3">
                  <Button
                    type="button"
                    color="primary"
                    outline={isInformative}
                    onClick={handleSetIsDefault}
                  >
                    <i className="bx bx-table" /> {t("Default")}
                  </Button>
                  <Button
                    className="ml-2"
                    type="button"
                    color="primary"
                    outline={!isInformative}
                    onClick={handleSetIsInformative}
                  >
                    <i className="bx bx-info-square" /> {t("Informative")}
                  </Button>
                </Row>
              </div>
              {messageOperator?.status?.tabulate_chat?.loading ? (
                <div style={{ padding: "1em" }}>
                  <Spinner
                    className="d-flex m-auto"
                    size="lg"
                    animation="border"
                  />
                </div>
              ) : (
                <>
                  <ModalBody>
                    {loadingMass ||
                    messageOperator?.status?.close_chat?.loading ||
                    messageOperator?.status?.tabulate_chat?.loading ? (
                      <Spinner
                        className="d-flex m-auto"
                        size="lg"
                        animation="border"
                      />
                    ) : isDisplayTabs ? (
                      <div>
                        <Tabulation
                          label={t("Tabulation")}
                          tabs={listGrandpaTabs}
                          value={
                            //Check if is single Tab
                            isSingleTab
                              ? listGrandpaTabs[0]
                              : listGrandpaTabs?.find(
                                  (item) => item.value === selectedGrandpaTab
                                ) ?? ""
                          }
                          onChange={(e) => {
                            setTabId(e.value);
                            setSelectedGrandpaTab(e.value);
                            setSelectedDadTab();
                            setSelectedChildTab();
                          }}
                          isLoading={
                            messageOperator?.status?.get_tabs_chat?.loading
                          }
                        />
                        {selectedGrandpaTab &&
                          listDadTabs[0]?.value !== "empty" && (
                            <Tabulation
                              tabs={listDadTabs}
                              value={
                                listDadTabs?.find(
                                  (item) => item.value === selectedDadTab
                                ) ?? ""
                              }
                              onChange={(e) => {
                                setTabId(e.value);
                                setSelectedDadTab(e.value);
                                setSelectedChildTab();
                              }}
                              isLoading={
                                messageOperator?.status?.get_tabs_chat?.loading
                              }
                            />
                          )}
                        {selectedDadTab &&
                          listChildTabs[0]?.value !== "empty" && (
                            <Tabulation
                              tabs={listChildTabs}
                              value={
                                listChildTabs?.find(
                                  (item) => item.value === selectedChildTab
                                ) ?? ""
                              }
                              onChange={(e) => {
                                setTabId(e.value);
                                setSelectedChildTab(e.value);
                              }}
                              isLoading={
                                messageOperator?.status?.get_tabs_chat?.loading
                              }
                            />
                          )}
                        {clientData.company === 'FacilAssist' && !notes && !isTicket &&
                          <FormGroup className="select2-container pl-3 w-100">
                              <AvField
                                id="private_note"
                                name="private_note"
                                type="textarea"
                                label={t("Private Note")}
                                placeholder={t("Digite o número da assistência (apenas dígitos)")}
                                className="form-control"
                                rows="3"
                                value={privateNoteFacilAssist ?? ""}
                                onKeyDown={(e) => {
                                  const isDigit = /^[0-9]$/.test(e.key);
                                  const isControl = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(e.key);
                                  const isShortcut = (e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase());
                                  if (!isDigit && !isControl && !isShortcut) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  setPrivateNoteFacilAssist(sanitizeToDigits(e.target.value));
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  setPrivateNoteFacilAssist(sanitizeToDigits(e.clipboardData.getData("text")));
                                }}
                              />
                          </FormGroup>
                        }
                      </div>
                    ) : (
                      <div className="modal-body font-size-18 text-center">
                        {massActions?.conversations?.length > 0
                          ? t("Do you want to close the selected chats?")
                          : t("Do you want to close chat?")}
                      </div>
                    )}

                    {loadingMass && (
                      <div className="modal-body font-size-18 text-center">
                        {`${numberOfReturns.current} / ${numberOfReturns.maximum}`}
                        <Progress
                          animated
                          value={
                            numberOfReturns.maximum === numberOfReturns.current
                              ? 100
                              : (numberOfReturns.current * 100) /
                                numberOfReturns.maximum
                          }
                        />
                      </div>
                    )}
                    {notes && (
                      <FormGroup className="select2-container pl-3 w-100">
                        <Label id="predefinedMessage-name-label">
                          {isTicket ? t("Public Note") : t("Notes")}
                        </Label>
                        <div className="textarea-container">
                          <TextareaAutosize
                            type="textarea"
                            ref={register}
                            name="notes"
                            className={setClassName(errors.notes)}
                            placeholder={t("Enter predefined message text")}
                            onChange={(e) => {
                              setText(e.target.value);
                            }}
                            defaultValue={text}
                          />
                        </div>
                        <div className="invalid-feedback d-block">
                          {t(errors.notes?.message)}
                        </div>
                        <div className={"d-block"}>
                          {t(`Total characters`)} {text?.length ?? 0}/2000
                        </div>
                        <>{renderGallery}</>
                        <>{renderChooseFile}</>
                        <div style={{ marginTop: "1em", maxWidth: "400px" }}>
                          {renderFilesLimitation}
                        </div>
                        {renderAttachedFiles}
                      </FormGroup>
                    )}
                    {isTicket && (
                      <FormGroup className="select2-container pl-3 w-100">
                        <Label id="predefinedMessage-name-label">
                          {t("Private Note") + ""}
                        </Label>
                        <div className="textarea-container">
                          <TextareaAutosize
                            type="textarea"
                            ref={register}
                            name="privateNote"
                            className={setClassName(errors.privateNote)}
                            placeholder={t("Enter predefined message text")}
                            onChange={(e) => {
                              setPrivateNote(e.target.value);
                            }}
                            defaultValue={privateNote}
                          />
                        </div>
                        <div className="invalid-feedback d-block">
                          {t(errors.privateNote?.message)}
                        </div>
                        <div className={"d-block"}>
                          {t(`Total characters`)} {privateNote?.length ?? 0}/600
                        </div>
                      </FormGroup>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <button
                      type="button"
                      onClick={toggle}
                      className={`btn ${
                        messageOperator?.status?.close_chat?.loading ||
                        messageOperator?.status?.tabulate_chat?.loading
                          ? "isDisabled"
                          : ""
                      }`}
                      disabled={
                        loadingMass ||
                        messageOperator?.status?.close_chat?.loading ||
                        messageOperator?.status?.tabulate_chat?.loading
                      }
                      style={{
                        background: "none",
                        color: "#556EE6",
                        borderColor: "#556EE6",
                      }}
                    >
                      {isTabsRequired ? t("Cancel") : t("No")}
                    </button>

                    <button
                      type="submit"
                      color="primary"
                      className="btn btn-primary"
                      disabled={
                        checkTabulation() ||
                        loadingMass ||
                        messageOperator?.status?.close_chat?.loading ||
                        messageOperator?.status?.tabulate_chat?.loading ||
                        messageOperator?.status?.get_tabs_chat?.loading ||
                        (actionType !== "tab" &&
                          isTabsRequired &&
                          isDisplayTabs &&
                          !tabId) ||
                        (actionType === "tab" && ((tabId === idToFind && !isInformative) || !tabId))
                          ? true
                          : false
                      }
                    >
                      {isTabsRequired ? t("Confirm Tabulation") : t("Yes")}
                    </button>
                  </ModalFooter>
                </>
              )}
            </>
          )}
        </AvForm>
      </Modal>
    </>
  );
};
export default withTranslation()(CloseChat);
